module.exports = __webpack_public_path__ + "img/06-trpg-material2021.91d8380b.png";